import { adminServerInstance } from "../axios/instances";
import {
    RETURN_HISTORY,
    RETURN_HISTORY_SUCCESS,
    RETURN_HISTORY_FAIL,
    GET_DRIVER_APP_RETURN_LIST,
    GET_DRIVER_APP_RETURN_LIST_SUCCESS,
    GET_DRIVER_APP_RETURN_LIST_FAIL,
    SELF_RETURN_MANUAL,
    SELF_RETURN_MANUAL_SUCCESS,
    SELF_RETURN_MANUAL_FAIL,
    GET_NEW_STORAGE_INFO,
    GET_NEW_STORAGE_INFO_SUCCESS,
    GET_NEW_STORAGE_INFO_FAIL
} from './types';

export function returnHistory(strat_time, end_time, driver_id){
    return function(dispatch){
        dispatch({type: RETURN_HISTORY})
        return adminServerInstance.post(`/storage/getselfreturnhistory`, {
            start_date: strat_time,
            driver_id: driver_id,
            end_date: end_time
        })
        .then(({data}) => {
            dispatch({
                type: RETURN_HISTORY_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: RETURN_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverAppReturnList(driver_id){
    return function(dispatch){
        dispatch({type: GET_DRIVER_APP_RETURN_LIST})
        return adminServerInstance.get(`/storage/getdriverappreturnlist?driver_id=${driver_id}`)
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_APP_RETURN_LIST_SUCCESS,
                payload: data
            })
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_APP_RETURN_LIST_FAIL,
                payload: error
            })
        });
    }
}

export function selfReturnManual(warehouse, tno){
    return function(dispatch){
        dispatch({type: SELF_RETURN_MANUAL})
        return adminServerInstance.post(`/business/selfreturnmanual`, {
            warehouse: warehouse,
            tno: tno
        })
        .then(({data}) => {
            dispatch({
                type: SELF_RETURN_MANUAL_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: SELF_RETURN_MANUAL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getNewStorageInfo(warehouse){
    return function(dispatch){
        dispatch({type: GET_NEW_STORAGE_INFO})
        return adminServerInstance.get(`/business/getnewstorageinfo?warehouse=${warehouse}`)
            .then(({data}) => {
                dispatch({
                    type: GET_NEW_STORAGE_INFO_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: GET_NEW_STORAGE_INFO_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}